import { Node, mergeAttributes } from "@tiptap/core"
import type { NodeViewProps } from "@tiptap/react"
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react"

/** 2026-09-17 block-editor design: a locked, non-editable chunk of HTML the
 *  backend already trusts (framework tables, annex, signature, header). The
 *  same conformity_renderer_v2 escaping rules built this markup server-side —
 *  it is rendered as-is here, never re-interpreted or edited client-side.
 *  `attrs.key` is what the merge step uses to find-and-replace this exact
 *  fragment on recompute; it carries no editable content of its own. */
export const SystemFragmentNode = Node.create({
  name: "systemFragment",
  group: "block",
  atom: true,
  selectable: false,
  draggable: false,

  addAttributes() {
    return {
      key: { default: null },
      html: { default: "" },
    }
  },

  parseHTML() {
    return [{ tag: "div[data-system-fragment]" }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, { "data-system-fragment": "" }),
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(SystemFragmentView)
  },
})

function SystemFragmentView({ node }: NodeViewProps) {
  return (
    <NodeViewWrapper
      as="div"
      data-system-fragment-key={
        typeof node.attrs.key === "string" ? node.attrs.key : undefined
      }
      // Trusted server-rendered HTML only (see module doc above) — this node
      // type never carries user input.
      dangerouslySetInnerHTML={{
        __html: typeof node.attrs.html === "string" ? node.attrs.html : "",
      }}
    />
  )
}
